// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileImageFilledSvg from "@ant-design/icons-svg/es/asn/FileImageFilled";
import AntdIcon from '../components/AntdIcon';

var FileImageFilled = function FileImageFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileImageFilledSvg
  }));
};

FileImageFilled.displayName = 'FileImageFilled';
export default React.forwardRef(FileImageFilled);